// extracted by mini-css-extract-plugin
export default {"loaderMask":"DashboardCreateForm_loaderMask__SXQnx","closeIcon":"DashboardCreateForm_closeIcon__r2zz5","createButton":"DashboardCreateForm_createButton__EWCgZ"};